import Button from '@mui/material/Button';
import { red } from '@mui/material/colors';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import uploadFile from '../../helpers/imageUpload';
import Image from 'components/FutureImage';

const redTheme = createTheme({
  palette: {
    primary: red,
  },
});

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

const FeaturedImageUpload = props => {
  const {
    featuredImage,
    setFeaturedImage,
    rounded,
    token,
    setFeaturedDimensions,
  } = props;

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
  } = useDropzone({
    accept: 'image/*',
    multiple: false,
    onDropAccepted: files => {
      files.map(file => {
        return uploadFile(file, {
          allowFullSize: props.allowFullSize,
          token,
        })
          .then(res => {
            setFeaturedImage(res.url);
            if (setFeaturedDimensions)
              setFeaturedDimensions({ height: res.height, width: res.width });
          })
          .catch(() => {
            // Failure (e.g. storage-quota hit) is surfaced globally by
            // <ImageQuotaNotifier>; just don't set a broken image here.
          });
      });
    },
  });

  const text =
    acceptedFiles && acceptedFiles.length > 0
      ? acceptedFiles.map(file => `Uploading ${file.path}...`)
      : props.placeholder;

  let profileStyle = {};
  if (props.profileStyle)
    profileStyle = {
      width: '250px',
      height: '250px',
    };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...profileStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject],
  );

  return (
    <div className="text-center">
      {(featuredImage && (
        <>
          <div style={{ maxHeight: '500px', overflow: 'hidden' }}>
            <Image
              alt="Featured"
              className={`img-fluid${rounded ? ' rounded-circle' : ''}`}
              src={featuredImage}
              style={rounded ? { height: '200px', width: '200px' } : {}}
              width={800}
              height={600}
              priority
            />
          </div>
          <div className="pt-2">
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={redTheme}>
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  onClick={() => setFeaturedImage(undefined)}
                >
                  Remove Image <DeleteIcon />
                </Button>
              </ThemeProvider>
            </StyledEngineProvider>
          </div>
        </>
      )) || (
        <div className="cpointer">
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <p>{text}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeaturedImageUpload;
